export const PAGES = {
  '/plugins': 'Plugins',
  '/people': 'People',
  '/features': 'Features',
  '/saml-sso': 'SAML SSO',
  '/reports': 'Reports',
  '/settings': 'Settings',
  '/settings/details': 'Team Details',
  '/settings/billing': 'Billing',
  '/settings/api-keys': 'API Keys',
} as const;

export type PageRoute = keyof typeof PAGES;
export type PageLabel = (typeof PAGES)[PageRoute];

export const SETTINGS_BASE_PATH: PageRoute = '/settings';
export const TAB_PATH = {
  TEAM_DETAILS: `${SETTINGS_BASE_PATH}/details`,
  API_KEYS: `${SETTINGS_BASE_PATH}/api-keys`,
  BILLING: `${SETTINGS_BASE_PATH}/billing`,
};
